<div class="backdrop">
  <div class="dialog">
    <pc-spinning-loader [isLarge]="true"></pc-spinning-loader>
    <span class="headline4">{{ translations.loading | translate }}</span>
  </div>
</div>
